import { styled } from '@mui/material/styles'
import { PickersDay, PickersDayProps } from '@mui/x-date-pickers-pro'

interface CustomPickersDayProps extends PickersDayProps<Date> {
  forWaitlist?: boolean
}

export const CustomPickersDay = styled(PickersDay, {
  shouldForwardProp: (prop) => prop !== 'selected' && prop !== 'forWaitlist',
})<CustomPickersDayProps>(({ theme, selected, forWaitlist }) => {
  if (!selected && forWaitlist) {
    return {
      color: theme.palette.text.secondary,
      '&:hover, &:focus': {
        backgroundColor: theme.palette.primary.shade60,
      },
      border: `1px dashed ${theme.palette.action.disabled} !important`,
    }
  }

  if (selected && forWaitlist) {
    return {
      backgroundColor: theme.palette.primary.shade12,
      color: theme.palette.text.primary,
      '&:hover, &:focus': {
        backgroundColor: theme.palette.primary.shade60,
      },
      border: '1px dashed black !important',
    }
  }

  if (selected && !forWaitlist) {
    return {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white,
      '&:hover, &:focus': {
        backgroundColor: theme.palette.primary.main,
      },
      borderRadius: '50%',
    }
  }

  return undefined
}) as React.ComponentType<CustomPickersDayProps>
